import axios from 'axios'
import { UserAuthenticationSingleton } from '../auth/UserAuthenticationSingleton'

const BASE_URL = process.env.REACT_APP_API_BASE_URL

const AxiosPost = (url, options) => {
    return new Promise((resolve, reject) => {
        axios
            .post(url, options, { headers: options.headers || {} })
            .then((response) => {
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

const AxiosPut = (url, options) => {
    return new Promise((resolve, reject) => {
        axios
            .put(url, options, { headers: options.headers || {} })
            .then((response) => {
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

const AxiosDelete = (url, options) => {
    return new Promise((resolve, reject) => {
        axios
            .delete(url, options, { headers: options.headers || {} })
            .then((response) => {
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

const authZeroFetch = (fetch, url, options) => {
    return new Promise((resolve, reject) => {
        const token = UserAuthenticationSingleton.getAccessToken()

        const o = options || {}
        if (!o.headers) o.headers = {}
        o.headers.Authorization = `Bearer ${token}`

        const fetchUrl = BASE_URL ? `${BASE_URL}${url}` : url
        fetch(fetchUrl, o)
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export { authZeroFetch, AxiosPost, AxiosPut, AxiosDelete }
